import { useQuery } from '@tanstack/react-query';

import { signupApi } from '../api/signup.adapter';
import { signupQueryKeys } from './use-signup-invitation';

// US-SU-05 — fetches the PUBLISHED Terms shown in the sign-up consent section.
// Token-gated; `enabled = !!token` so it doesn't fire without an invitation token.
// retry: false — the page already gates on the invitation query; a failed terms
// fetch surfaces an inline message rather than retrying.
export function useSignupTermsQuery(token: string | null) {
  return useQuery({
    queryKey: signupQueryKeys.terms(token ?? ''),
    queryFn: () => signupApi.listSignupTerms(token ?? ''),
    enabled: !!token,
    retry: false,
    staleTime: 0,
  });
}
